import React, {Component} from 'react';
import {Row, Col} from "react-bootstrap";
import TopIf from "../../../../componentsTopsa/if/TopIf";
import {TopButtonPointEdit} from "../../../../componentsTopsa/buttons/TopButtons";
import KlienciService from "../../KlienciService";


export default class KartaDanegoKlienta extends Component {
    constructor(props) {
        super(props);
        this.state = {
            klient: null,
            karta: null,
        };
    }

    componentDidMount() {
        this.ustawWartosci(this.props)
    }

    componentWillReceiveProps(nextprops) {
        this.ustawWartosci(nextprops)
    }

    ustawWartosci(props) {
        this.setState({
            klient: props.klient,
            karta: props.karta
        })
        if (Boolean(props.klient))
            this.wyszukajZdjecieKlienta(props.klient)
    }

    wyszukajZdjecieKlienta(klient) {
        KlienciService.getKlient(klient.idKl).then(function (response) {
            let profilowe = null

            if (response.data.pliki.length > 0) {
                if (Boolean(response.data.pliki.find(p => p.dokumentTyp == 'KLIENT_ZDJECIE'))) {
                    profilowe = (response.data.pliki.find(p => p.dokumentTyp == 'KLIENT_ZDJECIE')).dane
                }
            }


            let kl = klient
            kl.zdjecie = profilowe

            this.setState({klient: kl})

        }.bind(this)).catch(function (err) {
            console.log(err)
        }.bind(this))
    }

    render() {
        return (
            <div id={'KartaKlientaZDanymi'}>
                <div className={'thumbnail'} style={{padding: '15px'}}>
                    {
                        Boolean(this.state.klient) ?
                            <Row>
                                <Col xs={12} lg={4}>
                                    <div className={'thumbnail'} style={{marginBottom: 0}}>
                                        {
                                            Boolean(this.state.klient.zdjecie) ?
                                                <img src={'data:image/jpg;base64,' + this.state.klient.zdjecie}
                                                     className={'img-ressponsive'}/>
                                                :
                                                <div>
                                                    <p style={{textAlign:'center',padding:'30px 0', color:'#f0ad4e'}}>
                                                        <i className={'fa fa-exclamation-circle'}></i> Brak zdjęcia
                                                    </p>
                                                </div>
                                        }
                                    </div>
                                </Col>
                                <Col xs={12} lg={8} style={{fontSize: '16px'}}>
                                    <p style={{marginTop: '15px'}}>
                                        <span><i className={'fa fa-user'}></i> Imie i nazwisko:</span>
                                        <label>{this.state.klient.imie + ' ' + this.state.klient.nazwisko}</label>
                                    </p>
                                    <TopIf isTrue={this.state.klient.pesel}>
                                        <p>
                                            <span><i className={'fa fa-id-card-o'}></i> Nr Pesel:</span>
                                            <label>{this.state.klient.pesel}</label>
                                        </p>
                                    </TopIf>
                                    <TopIf isTrue={this.state.klient.nrTel}>
                                        <p>
                                            <span><i className={'fa fa-phone'}></i> Telefon:</span>
                                            <label>{this.state.klient.nrTel}</label>
                                        </p>
                                    </TopIf>
                                    <TopIf isTrue={this.state.klient.email}>
                                        <p>
                                            <span><i className={'fa fa-envelope'}></i> Email:</span>
                                            <label>{this.state.klient.email}</label>
                                        </p>
                                    </TopIf>
                                </Col>
                            </Row>
                            :
                            ''
                    }
                    <Row>
                        <Col xs={12}>
                            <div style={{margin: '15px 0', height: '1px', background: '#ddd'}}></div>
                        </Col>
                    </Row>
                    {
                        Boolean(this.state.karta) ?
                            <Row>
                                <Col xs={12}>
                                    <div style={{position: 'absolute', top: '0px', right: '15px', zIndex: '999999'}}>
                                        <TopButtonPointEdit onClick={() => {
                                            this.props.onEditKarta()
                                        }} titleContent={'Edytuj kartę'}/>
                                    </div>
                                </Col>
                                <Col xs={12} style={{fontSize: '14px'}}>
                                    <div style={{display: 'inline-block', paddingRight: '15px', borderRight: '1px solid #ddd'}}>
                                        <TopIf isTrue={this.state.karta.nazTr}>
                                            <p>
                                                <span><i className={'fa fa-road'}></i> Trasa:</span>
                                                <label>{this.state.karta.nazTr}</label>
                                            </p>
                                        </TopIf>
                                        <TopIf isTrue={this.state.karta.nazMiOd}>
                                            <p>
                                                <span><i className={'fa fa-map-marker'}></i> Od:</span>
                                                <label>{this.state.karta.nazMiOd}</label>
                                            </p>
                                        </TopIf>
                                        <TopIf isTrue={this.state.karta.nazMiDo}>
                                            <p>
                                                <span><i className={'fa fa-map-marker'}></i> Do:</span>
                                                <label>{this.state.karta.nazMiDo}</label>
                                            </p>
                                        </TopIf>
                                        <TopIf isTrue={this.state.karta.kierunek}>
                                            {
                                                (this.state.karta.kierunek == 1) ?
                                                    <p>
                                                        <span><i className={'fa fa-long-arrow-right'}></i> </span>
                                                        <label>W jedną stronę</label>
                                                    </p>
                                                    :
                                                    <p>
                                                        <span><i className={'fa fa-exchange'}></i> </span>
                                                        <label>W obu kierunkach</label>
                                                    </p>
                                            }

                                        </TopIf>
                                    </div>
                                    <div style={{display: 'inline-block', marginLeft: '15px'}}>

                                        <p>
                                            <span><i className={'fa fa-id-card-o'}></i> Numer karty:</span>
                                            {
                                                Boolean(this.state.karta.nrKarty)?
                                                    <label style={{fontWeight:'bold'}}>{this.state.karta.nrKarty}</label>
                                                :
                                                    <label style={{fontWeight:'bold', color:'firebrick'}}>Brak numeru karty <i className={'fa fa-exclamation-circle'}></i></label>
                                            }
                                        </p>
                                        {
                                            (this.state.karta.okres == 'M1') ?
                                                <p>
                                                                                    <span>
                                                                                    <i className={'fa fa-circle'}></i> Ważny przez:
                                                                                    </span><label>cały miesiąc</label>
                                                </p>
                                                :
                                                (this.state.karta.okres == 'P1') ?
                                                    <p>
                                                                                        <span>
                                                                                        <i className={'fa fa-adjust'}
                                                                                           style={{transform: 'rotate(180deg)'}}></i> Ważny przez:
                                                                                        </span><label>I połowę miesiąca</label>
                                                    </p>
                                                    :
                                                    <p>
                                                                                        <span>
                                                                                        <i className={'fa fa-adjust'}></i> Ważny przez:
                                                                                        </span><label>II połowę miesiąca</label>
                                                    </p>
                                        }
                                        <p>
                                            <span><i className={'fa fa-percent'}></i> Zniżka:</span>
                                            <span style={{marginLeft: '5px', color:'#fff', background:this.state.karta.kolor}} className={'label label-ebus-default'} >{this.state.karta.rodz}</span>
                                            <label>{this.state.karta.nazZniz}</label>
                                        </p>
                                        <p>
                                            <span><i className={'fa fa-check-circle-o'}></i> Status:</span>
                                            <label>{this.state.karta.status} {this.state.karta.status==='NOWA'? <i className={'fa fa-exclamation-circle'}
                                                                                                                   style={{marginLeft:'3px', color:'firebrick'}}></i>:''}</label>
                                        </p>
                                    </div>
                                </Col>
                            </Row>
                            :
                            ''
                    }
                </div>
            </div>
        )
    }
}




// WEBPACK FOOTER //
// ./src/modules/klienciConfig/klienci/externalComponents/KartaDanegoKlienta.js